import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retryDelay: (i) => Math.min(1000 * 2 ** i, 30000),
    },
    mutations: {
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        if (!status) return failureCount < 1;      // network: 1 retry
        return status >= 500 && failureCount < 1;  // 5xx: 1 retry
      },
    },
  },
});
